export default {
    formId: 'slaForm',
    formField: {
        slaTimes: {
            name: 'slaTimes',
            label: 'Tiempos de SLA'
        },
        // Campos de cada item en slaTimes
        level: {
            name: 'level',
            label: 'Nivel'
        },
        firstResponseValue: {
            name: 'firstResponseValue',
            label: 'Valor'
        },
        firstResponseUnit: {
            name: 'firstResponseUnit',
            label: 'Unidad'
        },
        resolutionValue: {
            name: 'resolutionValue',
            label: 'Valor'
        },
        resolutionUnit: {
            name: 'resolutionUnit',
            label: 'Unidad'
        }
    }
};
